<template>
  <div class="home">
    <HeroSection />
    <FeatureSection />
    <DomainSection />
    <PricingSection />
    <AnnouncementSection />
    <CtaBanner />
    <SiteFooter />
  </div>
</template>

<script setup>
import HeroSection from '@/components/HeroSection.vue'
import FeatureSection from '@/components/FeatureSection.vue'
import DomainSection from '@/components/DomainSection.vue'
import PricingSection from '@/components/PricingSection.vue'
import AnnouncementSection from '@/components/AnnouncementSection.vue'
import CtaBanner from '@/components/CtaBanner.vue'
import SiteFooter from '@/components/SiteFooter.vue'
</script>

<style scoped>
.home {
  width: 100%;
}
</style>
